import { injectable } from 'inversify';
import { UnitOptionUsePoint } from '@Models';
import { unit_option_full } from '@Api';

@injectable()
export class UnitOptionUsePointMapper {
  public map(item: unit_option_full.use_points): UnitOptionUsePoint {
    switch (item) {
      case unit_option_full.use_points.COST:
        return UnitOptionUsePoint.Cost;
      case unit_option_full.use_points.NO_COST:
        return UnitOptionUsePoint.NoCost;
      case unit_option_full.use_points.FREE:
        return UnitOptionUsePoint.Free;
      case unit_option_full.use_points.NO_LIMIT:
        return UnitOptionUsePoint.NoLimit;
      case unit_option_full.use_points.UP_TO:
        return UnitOptionUsePoint.UpTo;
    }
    return UnitOptionUsePoint.Cost;
  }
}
